/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, OnInit, OnDestroy, Inject, ChangeDetectorRef } from '@angular/core';
import { EmployeeModel } from '../../../models/employee.model';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeService } from '../../../services/employee.service';
import { Subscription } from 'rxjs';
import { AuthService, Logger, LogService } from '@epg/angular-base-lib';
import { AddEmployeeComponent } from './add-employee/add-employee.component';
import { MatDialog } from '@angular/material/dialog';
import { OneAppPermission } from '../../../enums/permission.enum';
import { faPlus, faSearch } from '@fortawesome/pro-regular-svg-icons';
import { PublicTenantManagerClient } from '@epg/tenant-manager-client';
import { getActiveTenantFromSessionStorage } from '../../../app/shared/functions';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss'],
  standalone: false
})
export class EmployeeComponent implements OnInit, OnDestroy {
  settingChangedSubscription: Subscription = new Subscription();
  employeesChangedSubscription: Subscription = new Subscription();
  employeeRouteChangeSub: Subscription = new Subscription();

  faSearch = faSearch;
  faPlus = faPlus;

  employees: EmployeeModel[] = [];
  totalLicenses: number = 0;
  tenant: string | undefined;
  currentUsersRoles: string[] = [];
  searchText: string = '';
  log: Logger;
  OneAppPermission = OneAppPermission;

  constructor(
    private logService: LogService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private employeeService: EmployeeService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private client: PublicTenantManagerClient
  ) {
    this.log = logService.getLogger(this);
  }

  async ngOnInit(): Promise<void> {
    this.tenant = getActiveTenantFromSessionStorage();
    this.employeesChangedSubscription = this.employeeService.employeesChanged.subscribe(
      (employees) => {
        this.employees = employees;
        this.log.debug(this.employees);
      }
    );
    this.employeeRouteChangeSub = this.employeeService.employeeRouteChange.subscribe((url) => {
      this.router.navigate([url], { relativeTo: this.route });
    });
    try {
      this.authService.getUserInfo().then(async (userInfo) => {
        this.currentUsersRoles = (
          await this.client
            .tenants(this.tenant ? this.tenant : '')
            .users(userInfo.username)
            .roles()
            .get()
        ).map((role) => {
          return role.name;
        });
      });
      try {
        this.employees = await this.employeeService.getEmployees();
      } catch (error) {
        console.log(error);
      }
      try {
        this.totalLicenses = await this.employeeService.getTotalLicenses();
      } catch (error) {
        console.log(error);
      }
    } catch (error) {
      console.log(error);
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.employeesChangedSubscription.unsubscribe();
    this.employeeRouteChangeSub.unsubscribe();
    this.settingChangedSubscription.unsubscribe();
  }
  onNewEmployeeClick() {
    this.dialog.open(AddEmployeeComponent, {
      width: '50vw',
      maxWidth: '90vw'
    });
  }
  isAdmin(): boolean {
    return this.currentUsersRoles.some((r) => r.toLowerCase() === 'administrator');
  }
}
